import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigCartNotesComponent } from './uig-cart-notes.component';
import { I18nModule } from '@spartacus/core';
import { UigCartNotesDialogComponent } from './uig-cart-notes-dialog/uig-cart-notes-dialog.component';
import { IconModule, SpinnerModule } from '@spartacus/storefront';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [UigCartNotesComponent, UigCartNotesDialogComponent],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    FormsModule,
    SpinnerModule
  ],
  exports: [UigCartNotesComponent]
})
export class UigCartNotesModule { }
